module.exports = __webpack_public_path__ + "img/partseven_user1.13a3f635.png";